module.exports = __webpack_public_path__ + "img/vuejs-brands.ddadc938.svg";